export default __webpack_public_path__ + "static/media/tk-b.0e57865e.png";